import { Component, EventEmitter, Input, Output, computed, signal } from '@angular/core';

interface TimeState {
  time: number;
  hours: number;
  minutes: number;
}

@Component({
  selector: 'app-task-view-comment-form-time',
  templateUrl: './task-view-comment-form-time.component.html',
  styleUrls: ['./task-view-comment-form-time.component.less'],
  imports: [],
  standalone: true,
})
export class TaskViewCommentFormTimeComponent {
  @Output() clear = new EventEmitter<void>();

  private readonly state = signal<TimeState>({
    time: 0,
    hours: 0,
    minutes: 0,
  });

  protected readonly hours = computed(() => this.state().hours);
  protected readonly minutes = computed(() => this.state().minutes);

  @Input()
  set time(value: number) {
    if (value === undefined || value === null) {
      return;
    }

    const hours = Math.floor(value);
    const minutes = Math.round((value - hours) * 60);

    this.state.update(state => ({
      ...state,
      time: value,
      hours,
      minutes,
    }));
  }

  get time(): number {
    return this.state().time;
  }
}
